export const plPL = {
  brand: 'MKProjectLab',
  concept: 'Projekt demonstracyjny',
  title: 'Kalkulator wyceny malowania wnętrz',
  subtitle: 'Zobacz, jak firma usługowa może zamienić dane o pomieszczeniach w pełniejsze i bardziej uporządkowane zapytanie.',
  intro: 'Przykład korzysta z demonstracyjnych stawek i uproszczonych reguł. Nie jest ofertą prawdziwej firmy malarskiej.',
  marketLabel: 'Rynek',
  marketUK: 'Wielka Brytania',
  marketPL: 'Polska',
  languageLabel: 'Język',
  start: 'Rozpocznij wycenę',
  step: 'Krok',
  of: 'z',
  back: 'Wstecz',
  next: 'Dalej',
  calculate: 'Oblicz wycenę',
  reset: 'Wyczyść kalkulator',
  resetConfirm: 'Usunąć wszystkie wprowadzone informacje?',
  addRoom: 'Dodaj kolejne pomieszczenie',
  duplicateRoom: 'Powiel pomieszczenie',
  removeRoom: 'Usuń',
  room: 'Pomieszczenie',
  rooms: 'Pomieszczenia',
  project: 'Projekt',
  dimensions: 'Wymiary',
  surfaces: 'Powierzchnie',
  condition: 'Stan',
  finish: 'Standard',
  result: 'Wycena',
  projectIntro: 'Wybierz rynek i region używany przez demonstracyjną konfigurację cenową.',
  propertyType: 'Rodzaj nieruchomości',
  propertyHouse: 'Dom',
  propertyFlat: 'Mieszkanie',
  propertyCommercial: 'Mały lokal usługowy',
  region: 'Region',
  regionStandardUK: 'Standard UK',
  regionLondon: 'Londyn i południowy wschód',
  regionStandardPL: 'Polska — stawka bazowa',
  regionWarsaw: 'Warszawa i okolice',
  travel: 'Dojazd',
  travelLocal: 'Lokalnie',
  travelExtended: 'Dalszy dojazd',
  travelOutside: 'Poza obszarem działania',
  roomType: 'Rodzaj pomieszczenia',
  customName: 'Własna nazwa pomieszczenia',
  typeLivingRoom: 'Salon',
  typeBedroom: 'Sypialnia',
  typeKitchen: 'Kuchnia',
  typeBathroom: 'Łazienka',
  typeHallway: 'Przedpokój',
  typeOffice: 'Biuro',
  typeOther: 'Inne',
  length: 'Długość',
  width: 'Szerokość',
  height: 'Wysokość',
  metres: 'metry',
  doors: 'Drzwi',
  windows: 'Okna',
  radiators: 'Grzejniki',
  dimensionsHelp: 'Podaj wewnętrzne wymiary. Model zakłada proste, prostokątne pomieszczenie.',
  paintWalls: 'Malowanie ścian',
  paintCeiling: 'Malowanie sufitu',
  paintSkirting: 'Malowanie listew przypodłogowych',
  paintedDoors: 'Drzwi i ościeżnice do malowania',
  paintedRadiators: 'Grzejniki do malowania',
  colourChange: 'Zmiana koloru',
  colourSimilar: 'Podobny kolor',
  colourNoticeable: 'Wyraźna zmiana koloru',
  colourDarkToLight: 'Bardzo ciemny na jasny',
  conditionLabel: 'Stan powierzchni',
  conditionGood: 'Dobry',
  conditionGoodHelp: 'Stabilne i czyste powierzchnie, wymagające typowego przygotowania.',
  conditionMinor: 'Drobne naprawy',
  conditionMinorHelp: 'Niewielkie otwory, rysy i miejscowe uzupełnienia.',
  conditionNoticeable: 'Wyraźne naprawy',
  conditionNoticeableHelp: 'Liczne ubytki, łuszcząca się farba lub większy zakres przygotowania.',
  conditionNewPlaster: 'Nowy tynk lub gładź',
  conditionNewPlasterHelp: 'Wymaga właściwego gruntowania lub warstwy przygotowawczej.',
  conditionSpecialist: 'Ocena specjalistyczna',
  conditionSpecialistHelp: 'Wilgoć, pleśń, aktywne zacieki lub niestabilne powierzchnie.',
  wallpaperRemoval: 'Usuwanie tapety',
  stainBlocking: 'Zabezpieczenie plam farbą izolującą',
  highCeiling: 'Wysokość powyżej 2,8 m',
  difficultAccess: 'Utrudniony dostęp',
  furnished: 'Mocno umeblowane lub zamieszkane pomieszczenie',
  risksTitle: 'Warunki wymagające indywidualnej oceny',
  moistureOrMould: 'Wilgoć, pleśń lub aktywne zacieki',
  unstableSurface: 'Niestabilny tynk lub odspajająca się powierzchnia',
  scaffoldingRequired: 'Wymagane rusztowanie lub specjalny dostęp',
  specialistFinish: 'Specjalne wykończenie dekoracyjne',
  fullReplastering: 'Pełne skuwanie lub ponowne tynkowanie',
  exteriorWork: 'Prace zewnętrzne',
  materialStandard: 'Standard materiałów',
  materialStandardValue: 'Standardowe materiały',
  materialPremium: 'Materiały premium',
  summaryTitle: 'Sprawdź zakres projektu',
  summarySubtitle: 'Zweryfikuj dane pomieszczeń przed obliczeniem demonstracyjnego przedziału.',
  estimateTitle: 'Orientacyjna wycena',
  estimateRange: 'Przedział wyceny',
  estimateCentral: 'Wartość obliczeniowa',
  manualTitle: 'Wymagana indywidualna ocena',
  manualBody: 'Projekt zawiera warunki, których nie należy wyceniać automatycznie. Zebrane dane nadal są podsumowane poniżej.',
  disclaimer: 'To orientacyjna wycena oparta na podanych informacjach. Nie stanowi wiążącej oferty. Ostateczna cena może wymagać zdjęć, oględzin i potwierdzenia stanu powierzchni.',
  conceptLabel: 'Projekt demonstracyjny MKProjectLab',
  conceptBody: 'Praktyczny przykład pokazujący, jak firma usługowa może zbierać lepsze zapytania i stosować własne reguły cenowe.',
  cta: 'Porozmawiaj o kalkulatorze dla swojej firmy',
  ctaNote: 'Demonstrator nie wysyła żadnych danych. Przycisk otwiera adres kontaktowy MKProjectLab.',
  surfacesSummary: 'Wybrany zakres',
  geometrySummary: 'Obliczone ilości',
  wallsArea: 'Ściany',
  ceilingArea: 'Sufit',
  skirtingLength: 'Listwy',
  noAutomaticPrice: 'Brak automatycznej ceny',
  required: 'To pole jest wymagane.',
  invalidNumber: 'Wprowadź liczbę w dozwolonym zakresie.',
  selectSurface: 'Wybierz co najmniej jedną powierzchnię lub element do malowania.',
  paintedCount: 'Liczba elementów do malowania nie może być większa niż liczba w pomieszczeniu.',
  maximumRooms: 'Demonstrator obsługuje maksymalnie pięć pomieszczeń.',
  errorsHeading: 'Popraw zaznaczone pola.',
  reasonLabels: {
    tooManyRooms: 'Więcej niż pięć pomieszczeń',
    noRooms: 'Nie dodano pomieszczeń',
    outsideServiceArea: 'Poza demonstracyjnym obszarem działania',
    specialistAssessment: 'Wybrano ocenę specjalistyczną',
    heightOverFour: 'Wysokość pomieszczenia przekracza 4 m',
    moistureOrMould: 'Wilgoć lub pleśń',
    unstableSurface: 'Niestabilna powierzchnia',
    scaffoldingRequired: 'Wymagane rusztowanie',
    specialistFinish: 'Specjalne wykończenie dekoracyjne',
    fullReplastering: 'Pełne skuwanie lub tynkowanie',
    exteriorWork: 'Prace zewnętrzne'
  }
} as const;
